export default "__VITE_PUBLIC_ASSET__73629a06__"